import React, { useEffect, useRef, useState } from "react";
import {
  ActionIcon,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  Group,
  Modal,
  Popover,
  Select,
  Stack,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import swal from "sweetalert";
import useStyles from "./style";
import CloseCircle from "../CloseCircle";
import { useDisclosure } from "@mantine/hooks";
import { getColor } from "../../pages/Home/Medication";
import moment from "moment";
import PRNMedicationModal from "../PRNMedicationModal";
import MedicationModal from "../MedicationModal";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";
import { createMar, getMar } from "../../services";
import { FaInfinity } from "react-icons/fa6";
import { IconChevronDown, IconClock } from "@tabler/icons-react";
import { DatePicker, DateTimePicker, TimeInput } from "@mantine/dates";
import dayjs from "dayjs";
import { SlCalender } from "react-icons/sl";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const MarMedicationModal = ({
  data,
  date,
  close,
  opened,
  calendar,
  futureDate,
  currentDate,
}) => {
  const { classes } = useStyles();
  const [btnLoading, setBtnLoading] = useState(false);
  const { selectedClient } = useSelector((state) => state.mar);
  const { profile } = useSelector((state) => state.profile);
  const [selectedMedicine, setSelectedMedicine] = useState([]);
  const [selectedDate, setSelectedDate] = useState(currentDate);
  const [filteredWeekData, setFilteredData] = useState();

  let userid = profile?.user?.id;
  const form = useForm({
    initialValues: {
      quantity: "0",
      reason: "",
      comments: "",
      outcome: "",
    },
  });

  const compareDate = (date, medicationType, upcoming) => {
    var time1 = moment(date).startOf("day");
    var today = moment().startOf("day");
    if (
      calendar !== "weekly" &&
      calendar !== "monthly" &&
      medicationType === upcoming
    ) {
      return -1;
    } else if (time1.isSame(today)) {
      return 0;
    } else if (time1.isAfter(today)) {
      return 1;
    } else {
      return -1;
    }
  };

  const selectMedicineHandler = (_v) => {
    if (selectedMedicine?.filter((val) => val?._id == _v?._id)?.length > 0) {
      let filteredMed = selectedMedicine?.filter((val) => val?._id != _v?._id);
      setSelectedMedicine(filteredMed);
    } else {
      setSelectedMedicine([...selectedMedicine, _v]);
    }
  };

  useEffect(() => {
    if (opened) {
      form.setFieldValue("quantity", String(data?.dosage));
    }
  }, []);

  const [dateTimeOpened, setDateTimeOpened] = useState(false);
  const [tempDate, setTempDate] = useState(
    form.values.createdAt ? new Date(form.values.createdAt) : null
  );
  const [tempTime, setTempTime] = useState(
    form.values.createdAt ? dayjs(form.values.createdAt).format("HH:mm") : ""
  );

  const [validation, setValidation] = useState({
    comments: (value) => (value ? null : "Required"),
  });

  useEffect(() => {
    setValidation((prevValidation) => ({
      ...prevValidation,
    }));
  }, [form?.values?.comments]);

  const formatDisplayValue = (date, time) => {
    if (!date) return "";

    if (time) {
      const [hours, minutes] = time.split(":");
      const dateTime = new Date(date);
      dateTime.setHours(parseInt(hours), parseInt(minutes));
      return dayjs(dateTime).format("MMM DD, YYYY - hh:mm A");
    }

    return dayjs(date).format("MMM DD, YYYY");
  };

  const handleDateTimeApply = () => {
    if (tempDate && tempTime) {
      const [hours, minutes] = tempTime.split(":");
      const dateTime = new Date(tempDate);
      dateTime.setHours(parseInt(hours), parseInt(minutes));

      form.setFieldValue("createdAt", dateTime);
      setDateTimeOpened(false);
    } else if (tempDate) {
      form.setFieldValue("createdAt", tempDate);
      setDateTimeOpened(false);
    }
  };

  const handleDateTimeClear = () => {
    setTempDate(null);
    setTempTime("");
    setDateTimeOpened(false);
  };

  useEffect(() => {
    if (dateTimeOpened && !form.values.createdAt) {
      setTempDate(new Date());
      setTempTime(dayjs().format("HH:mm"));
    }
  }, [dateTimeOpened]);

  const onSave = async (values, type) => {
    const uniqueArray = selectedMedicine?.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t?.medicationId === value?.medicationId)
    );
    let medicationName = null;
    let redFlag = false;
    let i = 0;
    do {
      let filterMedication = selectedMedicine?.filter(
        (item) => item?.medicationId == uniqueArray[i]?.medicationId
      );
      let count = 0;
      filterMedication?.map((item) => {
        count += Number(item?.form3?.medicationadministered);
      });

      if (count > uniqueArray[i]?.form3?.medicineRemaining) {
        redFlag = true;
        medicationName = uniqueArray[i]?.form3?.medicationName;
      }
      i++;
    } while (i < uniqueArray?.length && !redFlag);

    if (redFlag && type === "Taken") {
      swal({
        title: `${medicationName} is overfilled`,
        text: "Medication Overfilled",
        icon: "info",
        dangerMode: true,
        buttons: ["Cancel", "Ok"],
      });
    } else if (!redFlag || type != "Taken") {
      const sortMedicine = (data) => {
        return data.sort((a, b) => {
          const timeA =
            a?.medicationType !== "PRN"
              ? moment(a?.timeSlot, "hh:mm A").format("HH:mm")
              : moment(a?.createdAt).format("HH:mm");
          const timeB =
            b?.medicationType !== "PRN"
              ? moment(b?.timeSlot, "hh:mm A").format("HH:mm")
              : moment(b?.createdAt).format("HH:mm");

          return timeA.localeCompare(timeB);
        });
      };

      const sortedMedicine = sortMedicine(selectedMedicine);

      const getCreatedAt = (item) => {
        if (form.values?.createdAt) {
          return form.values.createdAt;
        }

        // If medication row has its own createdAt, use it
        // if (item?.createdAt) {
        //   return item.createdAt;
        // }

        // Otherwise fallback to timeslot-based calculation
        if (item?.timeSlot) {
          const today = moment().format("YYYY-MM-DD");
          const dateTime = moment(
            `${today} ${item.timeSlot}`,
            "YYYY-MM-DD hh:mm A"
          );
          return dateTime.toISOString();
        }

        // Last fallback = now
        return moment().toISOString();
      };

      let payload = {
        client: selectedClient?.id,
        medicationType: data?.form3?.medicationType === "PRN" ? "PRN" : type,
        // date: moment(selectedDate).toISOString(),
        date:
          calendar === "weekly"
            ? moment(selectedDate).toISOString()
            : moment(date).toISOString(),
        // createdAt: form.values?.createdAt || moment().toISOString(),
        // createdAt:
        //   form.values?.createdAt?.toISOString() || moment(date).toISOString(),
        // createdAt: getCreatedAt(),
        staff: selectedStaff || userid,
        medicationDetails: [],
        included: [],
        comments: form?.values?.comments,
      };

      sortedMedicine?.forEach((data) => {
        payload.medicationDetails.push({
          marId: data?._id,
          medicationId: data?.medicationId,
          dosage: data?.form3?.medicationadministered
            ? Number(data?.form3?.medicationadministered)
            : 0,
          slot: data?.timeSlot,
          createdAt: getCreatedAt(data),
          comments: data?.comments,
        });
      });

      let allSortedMedicine = [];
      if (calendar === "weekly") {
        allSortedMedicine = sortMedicine(filteredWeekData);
      } else {
        allSortedMedicine = sortMedicine(data);
      }

      function convertTo24HourFormat(time) {
        const [hour, minute, period] = time
          .match(/(\d+):(\d+)\s*(AM|PM)/)
          .slice(1);
        let hour24 = parseInt(hour);

        if (period === "AM" && hour24 === 12) {
          hour24 = 0; // Midnight case (12:00 AM -> 00:00)
        } else if (period === "PM" && hour24 !== 12) {
          hour24 += 12; // PM times, except for 12 PM, need 12 added
        }

        if (hour24 < 10) {
          return `0${hour24}:${minute}`;
        } else {
          return `${hour24}:${minute}`;
        }
      }

      // Function to get filtered data for multiple selections
      function getFilteredDataForMultiple(data, selectedObjects) {
        const results = [];

        selectedObjects.forEach((selectedObject) => {
          const { medicationId, slot } = selectedObject;
          const selectedTime = convertTo24HourFormat(slot);

          // Filter the array for each selected object
          // const filtered = data.filter(
          //   (item) =>
          //     item.medicationId === medicationId &&
          //     convertTo24HourFormat(item.timeSlot) >= selectedTime
          // );

          const filtered = data
            .filter(
              (_fitem) =>
                _fitem.medicationId === medicationId &&
                (convertTo24HourFormat(_fitem.timeSlot) == selectedTime ||
                  convertTo24HourFormat(_fitem.timeSlot) > selectedTime)
            )
            .map((_mitem) => {
              if (
                selectedMedicine?.filter((_s) => _s?._id === _mitem?._id)
                  ?.length > 0
              ) {
                return {
                  ..._mitem,
                  newMedicationType: type,
                };
              } else {
                return {
                  ..._mitem,
                  newMedicationType: _mitem?.medicationType,
                };
              }
            });

          // Add the filtered results
          results.push(
            ...filtered?.map((_f) => {
              return {
                marId: _f?._id,
                medicationId: _f?.medicationId,
                dosage:
                  _f?.medicationType === "Taken"
                    ? Number(_f?.dosage)
                    : Number(_f?.form3?.medicationadministered),
                slot: _f?.timeSlot,
                newMedicationType: _f?.newMedicationType,
                createdAt: getCreatedAt(_f),
              };
            })
          );
        });

        // Remove duplicates from the results (if needed)
        return results.filter(
          (obj, index, self) =>
            index === self.findIndex((o) => o.marId === obj.marId)
        );
      }

      const myResult = getFilteredDataForMultiple(
        allSortedMedicine,
        payload?.medicationDetails
      );

      const sortMars = (data) => {
        return data.sort((a, b) => {
          const timeA =
            a?.medicationType !== "PRN"
              ? moment(a?.slot, "hh:mm A").format("HH:mm")
              : moment(a?.createdAt).format("HH:mm");
          const timeB =
            b?.medicationType !== "PRN"
              ? moment(b?.slot, "hh:mm A").format("HH:mm")
              : moment(b?.createdAt).format("HH:mm");

          return timeA.localeCompare(timeB);
        });
      };

      const sortResult = sortMars(myResult);

      payload.included = sortResult;

      setBtnLoading(true);
      try {
        const res = await createMar(payload);
        if (res) {
          let calendar_view = localStorage.getItem("calendar_date");
          getMar(calendar_view, selectedClient?.id);
          form.reset();
          close();
        }
      } catch (error) {}
      setBtnLoading(false);

      // } else {
      //   alert("Quantity is Required!");
      // }
    }
  };

  useEffect(() => {
    handleDateChange(currentDate);
  }, [data]);

  const handleDateChange = (value) => {
    setSelectedDate(value);
    const filteredWeekData = data?.filter(
      (item) =>
        moment(item?.date).format("YYYY-MM-DD") ==
        moment(value).format("YYYY-MM-DD")
    );
    setFilteredData(filteredWeekData);
  };

  const { staff } = useSelector((state) => state?.staff);
  const [selectedStaff, setSelectedStaff] = useState();

  const assignedStaffIds = selectedClient?.staff
    ?.filter((s) => s?.isAssign === true)
    ?.map((s) => s?.staffId);

  const populateStaff = staff?.staffs
    ?.filter((staff) => assignedStaffIds?.includes(staff?.id))
    ?.map((staff) => ({
      label: staff?.name,
      value: staff?.id,
    }));

  // const [populateStaff, setPopulateStaff] = useState();

  // useEffect(() => {
  //   const staffOptions =
  //     staff?.staffs?.map((item) => ({
  //       value: item?.id,
  //       label: item?.name,
  //     })) || [];

  //   const defaultStaff = profile?.user?.id
  //     ? {
  //         value: profile?.user?.id,
  //         label: profile?.user?.name,
  //       }
  //     : null;

  //   // Add default staff if not already in the list
  //   const isDefaultInList = staffOptions.some(
  //     (opt) => opt.value === defaultStaff?.value
  //   );
  //   const finalOptions =
  //     defaultStaff && !isDefaultInList
  //       ? [defaultStaff, ...staffOptions]
  //       : staffOptions;

  //   setPopulateStaff(finalOptions);
  //   setSelectedStaff(defaultStaff?.value || null);
  // }, [staff, profile]);

  const handleClose = () => {
    setSelectedMedicine([]);
    form.reset();
    close();
  };

  const isFuture = dayjs.utc(date).isAfter(dayjs.utc());

  return (
    <>
      <Modal
        size={850}
        centered
        shadow="md"
        radius={"lg"}
        zIndex={1000}
        opened={opened}
        onClose={() => {
          handleClose();
        }}
        overlayProps={{ blur: 3 }}
        className={classes.marDetailModal}
      >
        <CloseCircle onclose={handleClose} />
        <Box className={classes.header} h={calendar === "weekly" ? 140 : 100}>
          <Flex align={"center"} gap={10} justify={"space-between"}>
            {profile?.user?.role !== "staff" && (
              <Select
                data={populateStaff}
                value={selectedStaff}
                placeholder="Select Staff"
                label="Select Staff"
                onChange={(e) => setSelectedStaff(e)}
                rightSection={<IconChevronDown size={16} />}
                nothingFound="No staff found"
                w={200}
                m={5}
                // {...adminForm.getInputProps("staff")}
              />
            )}

            {calendar !== "weekly" && (
              // <DateTimePicker
              //   label="Select Administration date and time"
              //   placeholder="Select Administration date and time"
              //   timePickerProps={{
              //     withDropdown: true,
              //     popoverProps: { withinPortal: false },
              //     format: "12h",
              //   }}
              //   valueFormat="MMM DD, YYYY - hh:mm A"
              //   size="sm"
              //   // disabled={isViewOpen || futureDate == 1}
              //   maxDate={new Date()}
              //   defaultValue={form.values.createdAt}
              //   {...form.getInputProps("createdAt")}
              // />
              <Popover
                opened={dateTimeOpened}
                onClose={() => setDateTimeOpened(false)}
                position="bottom-start"
                withinPortal={false}
                shadow="md"
                radius="md"
              >
                <Popover.Target>
                  <TextInput
                    label="Select Administration date and time"
                    placeholder="Select Administration date and time"
                    value={formatDisplayValue(
                      form.values.createdAt
                        ? new Date(form.values.createdAt)
                        : null,
                      form.values.createdAt
                        ? dayjs(form.values.createdAt).format("HH:mm")
                        : ""
                    )}
                    onClick={() => {
                      if (!tempDate) setTempDate(new Date());
                      if (!tempTime) setTempTime(dayjs().format("HH:mm"));
                      setDateTimeOpened(true);
                    }}
                    readOnly
                    withAsterisk
                    size="md"
                    styles={{
                      input: {
                        cursor: "pointer",
                      },
                    }}
                    error={form.errors.createdAt}
                  />
                </Popover.Target>

                <Popover.Dropdown>
                  <Stack spacing="md" p="sm">
                    <DatePicker
                      value={tempDate}
                      onChange={(date) => {
                        setTempDate(date);
                      }}
                      maxDate={new Date()}
                      size="sm"
                    />

                    <TimeInput
                      label="Select Time"
                      placeholder="Select time"
                      value={tempTime}
                      onChange={(event) => {
                        setTempTime(event.currentTarget.value);
                      }}
                      withAsterisk
                      size="sm"
                      icon={<IconClock size={16} />}
                      format="12"
                      withDropdown
                    />

                    <Group position="apart" mt="md">
                      <Button
                        variant="subtle"
                        color="gray"
                        size="xs"
                        onClick={handleDateTimeClear}
                      >
                        Clear
                      </Button>

                      <Group spacing="xs">
                        <Button
                          variant="default"
                          size="xs"
                          onClick={() => setDateTimeOpened(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          size="xs"
                          onClick={handleDateTimeApply}
                          disabled={!tempDate}
                          style={{
                            backgroundColor: "#fab005",
                            color: "#000",
                          }}
                        >
                          Apply
                        </Button>
                      </Group>
                    </Group>
                  </Stack>
                </Popover.Dropdown>
              </Popover>
            )}
          </Flex>
          <Flex align={"center"} gap={10} justify={"space-between"}>
            <Text size="xl" weight={500} ff={"inter"}>
              Select Medication
            </Text>

            {calendar === "weekly" ? (
              <Select
                label="Select Date"
                value={selectedDate}
                onChange={handleDateChange}
                nothingFound="No medication found"
                data={date?.map((item, index) => ({
                  value: item,
                  label: moment(item).format("dddd (MMM DD, YYYY)"),
                }))}
                placeholder={
                  currentDate
                    ? moment(currentDate).format("dddd (MMM DD, YYYY)")
                    : "Select a date"
                }
                rightSection={<IconChevronDown size={16} />}
                defaultValue={
                  currentDate
                    ? moment(currentDate).format("dddd (MMM DD, YYYY)")
                    : "Select a date"
                }
              />
            ) : (
              <Text c={"dimmed"} ff={"inter"}>
                {date}
              </Text>
            )}
          </Flex>
        </Box>

        <Box className={classes.modalWrapper}>
          {/* Select Medicines */}
          {/* <Flex mt={10} ml={10} mb={5} gap="10px">
            <Checkbox
              label="Select All"
              disabled={isFuture || compareDate(selectedDate) === 1}
              checked={(() => {
                const filtered =
                  calendar === "weekly" ? filteredWeekData : data;
                const missed = filtered?.filter((_v) => _v?.medicationType === "Missed");
                return (
                  selectedMedicine?.length === missed?.length &&
                  missed?.length > 0
                );
              })()} // ✅ Now this is a boolean
              color="yellow"
              onClick={() => {
                const filtered =
                  calendar === "weekly" ? filteredWeekData : data;
                const missed = filtered?.filter((_v) => _v?.medicationType === "Missed");

                if (selectedMedicine?.length === missed?.length) {
                  setSelectedMedicine([]);
                } else {
                  setSelectedMedicine(missed);
                }
              }}
            />
          </Flex> */}
          <Flex mt={10} ml={10} mb={5} gap="10px">
            <Checkbox
              label="Select All"
              disabled={isFuture || compareDate(selectedDate) === 1}
              checked={(() => {
                const filtered =
                  calendar === "weekly" ? filteredWeekData : data;

                // Filter "Missed" medications and today's "upcoming" medications
                const selectableMedications = filtered?.filter((_v) => {
                  if (_v?.medicationType === "Missed") {
                    return true;
                  }
                  // Include "upcoming" only if it's today's date
                  if (_v?.medicationType === "upcoming") {
                    const medDate = moment(_v?.date).startOf("day");
                    const today = moment().startOf("day");
                    return medDate.isSame(today);
                  }
                  return false;
                });

                // Check if all selectable medications are selected
                const allSelected = selectableMedications?.every((med) =>
                  selectedMedicine?.some(
                    (selected) => selected?._id === med?._id
                  )
                );

                return allSelected && selectableMedications?.length > 0;
              })()}
              color="yellow"
              onClick={() => {
                const filtered =
                  calendar === "weekly" ? filteredWeekData : data;

                // Filter "Missed" medications and today's "upcoming" medications
                const selectableMedications = filtered?.filter((_v) => {
                  if (_v?.medicationType === "Missed") {
                    return true;
                  }
                  // Include "upcoming" only if it's today's date
                  if (_v?.medicationType === "upcoming") {
                    const medDate = moment(_v?.date).startOf("day");
                    const today = moment().startOf("day");
                    return medDate.isSame(today);
                  }
                  return false;
                });

                // Check if all selectable are currently selected
                const allSelected = selectableMedications?.every((med) =>
                  selectedMedicine?.some(
                    (selected) => selected?._id === med?._id
                  )
                );

                if (allSelected) {
                  // Deselect all selectable medications
                  const remainingSelected = selectedMedicine?.filter(
                    (selected) =>
                      !selectableMedications?.some(
                        (sel) => sel?._id === selected?._id
                      )
                  );
                  setSelectedMedicine(remainingSelected);
                } else {
                  // Select all selectable medications (keep existing selections + add new ones)
                  const newSelections = [...selectedMedicine];
                  selectableMedications?.forEach((med) => {
                    if (!newSelections?.some((sel) => sel?._id === med?._id)) {
                      newSelections.push(med);
                    }
                  });
                  setSelectedMedicine(newSelections);
                }
              }}
            />
          </Flex>
          {/* Select Medicines */}
          <Box className={classes.medBody}>
            {(calendar === "weekly" ? filteredWeekData : data)?.length > 0 ? (
              (calendar === "weekly" ? filteredWeekData : data)
                ?.sort((a, b) => new Date(a?.date) - new Date(b?.date))
                ?.map((v, i) => (
                  <div
                    className={classes.cardWrapper}
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Checkbox
                      checked={selectedMedicine.some(
                        (val) => val?._id === v?._id
                      )}
                      disabled={
                        // v?.medicineRemaining === "unlimited" ||
                        // v?.totalMedicine === "unlimited" ||
                        isFuture ||
                        compareDate(date) === 1 ||
                        compareDate(selectedDate) === 1 ||
                        futureDate === 1 ||
                        v?.medicationType === "Taken" ||
                        v?.medicationType === "Refused" ||
                        v?.medicationType === "Unable to Take" ||
                        v?.medicationType === "Out of Medication" ||
                        v?.medicationType === "PRN"
                      }
                      color="yellow"
                      onClick={() => selectMedicineHandler(v)}
                    />
                    <Card
                      data={v}
                      allData={data}
                      calendar={calendar}
                      date={date}
                    />
                  </div>
                ))
            ) : (
              <Center style={{ height: "350px" }}>
                <Text ff={"inter"} c={"dimmed"} fw={500} fs={"16px"}>
                  No Medication Found
                </Text>
              </Center>
            )}
          </Box>
        </Box>
        <Box className={classes.comments} style={{ marginTop: "10px" }}>
          <Textarea
            id="dosage-completed"
            minRows={2}
            label="Comments"
            disabled={selectedMedicine?.length === 0 || btnLoading}
            placeholder="Enter comments here"
            defaultValue={form.values.comments}
            {...form.getInputProps("comments")}
          />
        </Box>

        <Box className={classes.buttons}>
          <Box className={classes.topButtons}>
            <Button
              size="xs"
              radius="md"
              variant="light"
              // onClick={() => onSave(form.values, "Refused")}
              onClick={() => {
                const commentError = validation.comments(form.values.comments);
                if (commentError) {
                  form.setFieldError("comments", commentError);
                  return;
                }
                onSave(form.values, "Refused");
              }}
              disabled={selectedMedicine?.length === 0 || btnLoading}
            >
              Refused
            </Button>
            <Button
              size="xs"
              radius="md"
              color="yellow"
              variant="outline"
              onClick={() => {
                const commentError = validation.comments(form.values.comments);
                if (commentError) {
                  form.setFieldError("comments", commentError);
                  return;
                }
                onSave(form.values, "Unable to Take");
              }}
              // onClick={() => onSave(form.values, "Unable to Take")}
              disabled={selectedMedicine?.length === 0 || btnLoading}
            >
              Unable to Take
            </Button>
            <Button
              size="xs"
              c="black"
              radius="md"
              color="gray"
              variant="outline"
              disabled={
                selectedMedicine?.length === 0 || btnLoading || futureDate == 1
                // ||
                // selectedMedicine?.some(
                //   (_m) =>
                //     _m?.medicineRemaining === "unlimited" &&
                //     _m?.totalMedicine === "unlimited"
                // )
              }
              //onClick={() => onSave(form.values, "Out of Medication")}

              onClick={() => {
                const commentError = validation.comments(form.values.comments);
                if (commentError) {
                  form.setFieldError("comments", commentError);
                  return;
                }
                onSave(form.values, "Out of Medication");
              }}
            >
              Out of Medication
            </Button>
          </Box>
          <Button
            size="xs"
            fullWidth
            radius="md"
            color="green"
            variant="filled"
            loading={btnLoading}
            onClick={() => onSave(form.values, "Taken")}
            disabled={selectedMedicine?.length === 0 || btnLoading}
          >
            Save as Taken
          </Button>
          <Box></Box>
        </Box>
      </Modal>
    </>
  );
};

const Card = ({ data, allData, calendar, date }) => {
  const { classes } = useStyles();
  const _medicationType = data?.medicationType;
  const _outOfMedication = "Out of Medication";
  const _upcoming = "upcoming";

  const { selectedClient } = useSelector((state) => state.mar);

  const [opened, { open, close }] = useDisclosure(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [prnShow, setPRNShow] = useState(false);
  const [isNew, setIsNew] = useState(true);

  const prnRef = useRef();

  const compareDate = (date, medicationType, upcoming) => {
    var time1 = moment(date).startOf("day"); // Set time to the start of the day
    var today = moment().startOf("day");
    if (
      calendar !== "weekly" &&
      calendar !== "monthly" &&
      medicationType === upcoming
    ) {
      return -1;
    } else if (time1.isSame(today)) {
      return 0;
    } else if (time1.isAfter(today)) {
      return 1;
    } else {
      return -1;
    }
  };

  const openPRNView = (data) => {
    setIsNew(false);
    prnRef?.current?.openView(data);
    setPRNShow(true);
  };
  const prnClose = () => {
    setSelectedRow(null);
    setPRNShow(false);
  };

  return (
    <div>
      <div
        className={`${classes.cardContainer} ${
          _medicationType === _outOfMedication ? classes.outOfmedication : ""
        }`}
        style={{
          backgroundColor: getColor(_medicationType)?.dark,
          cursor: compareDate(data?.date) === 1 ? "not-allowed" : "pointer",
          width: "800px",
        }}
        onClick={() => {
          setSelectedRow(data);
          if (data?.form3?.medicationType === "PRN") {
            return openPRNView(data);
          }

          if (compareDate(data?.date) === 1) {
            setIsViewOpen(false);
          } else {
            _medicationType === _upcoming || _medicationType === "Missed"
              ? setIsViewOpen(false)
              : setIsViewOpen(true);
            open();
          }
        }}
      >
        <div className={classes.box1}>
          <div>
            <h3>{data?.form3?.frequency}</h3>
            {/* <p>{data?.timeSlot}</p> */}
          </div>
          {data?.form3?.isNarcotic == "Yes" && (
            <img src="/assets/images/narcotic.png" alt="" />
          )}
        </div>
        <div className={classes.box2}>
          <div>
            <h2>{data?.form3?.medicationName}</h2>
            <p>
              {data?.form3?.dosage} {data?.form3?.unit}
            </p>
          </div>
          <p>
            {data?.form3?.ingestionMode} {data?.form3?.dosageForm}
          </p>
        </div>
        <div className={classes.box3}>
          {/* <p>{data?.staff?.name}</p> */}

          {data?.medicationType !== "Missed" ? (
            <>
              <p>Recorded by:</p>
              <p>{data?.staff?.name}</p>
            </>
          ) : null}
          <div>
            <p>{data?.timeSlot}</p>
            {/* <p>{moment(data?.createdAt).format("h:mm A")}</p> */}
            {_medicationType === "Taken" && (
              <img
                src={"/assets/images/done-icon.png"}
                style={{ width: "15px", height: "15px" }}
                alt="done"
              />
            )}
            {_medicationType === "Missed" && (
              <img
                src={"/assets/images/warning.png"}
                style={{ width: "15px", height: "15px" }}
                alt="warning"
              />
            )}
            {_medicationType === "Unable to Take" && (
              <img
                src={"/assets/images/do-not-disturb.png"}
                style={{ width: "15px", height: "15px" }}
                alt="do-not-disturb"
              />
            )}
            {_medicationType === "Refused" && (
              <img
                src={"/assets/images/unavailable.png"}
                style={{ width: "15px", height: "15px" }}
                alt="unavailable"
              />
            )}
            {_medicationType === "Out of Medication" && (
              <img
                src={"/assets/images/close-white.png"}
                style={{ width: "15px", height: "15px" }}
                alt="close"
              />
            )}
          </div>
        </div>

        <div
          className={classes.box4}
          style={{
            marginRight: "10px",
            border:
              _medicationType === _outOfMedication
                ? "1px solid #fff"
                : "1px solid black",
          }}
        >
          <h3>
            {data?.medicationType === "Taken"
              ? data?.dosage
              : data?.form3?.medicationadministered}
          </h3>
          <p>Quantity Dispensed</p>
        </div>
        <div
          className={classes.box4}
          style={{
            border:
              _medicationType === _outOfMedication
                ? "1px solid #fff"
                : "1px solid black",
          }}
        >
          <h3>
            {data?.medicineRemaining === "unlimited" ? (
              <FaInfinity />
            ) : data?.medicineRemaining == null ||
              data?.medicineRemaining == "null" ? (
              "0.0"
            ) : (
              Number(data?.medicineRemaining).toFixed(1)
            )}

            {/* // Number(data?.medicineRemaining).toFixed(1) */}
            {/* {data?.medicineRemaining
              ? data?.form3?.medicineRemaining
              : data?.medicineRemaining} */}
            {/* {data?.form3?.medicineRemaining > 0
              ? data?.form3?.medicineRemaining
                ? data?.form3?.medicineRemaining
                : data?.medicineRemaining
              : "0"} */}
          </h3>
          {data?.medicineRemaining !== "unlimited" && (
            <p
              style={{
                color:
                  _medicationType === _outOfMedication ? "#fff" : "initial",
              }}
            >
              of {Number(data?.totalMedicine).toFixed(1)} <br />
              Remaining
            </p>
          )}
          {/* <p>
            of {data?.form3?.totalMedicine} <br />
            Remaining
          </p> */}
        </div>
      </div>
      <PRNMedicationModal
        isNew={isNew}
        ref={prnRef}
        opened={prnShow}
        onclose={prnClose}
        data={selectedClient}
        date={date}
      />
      <MedicationModal
        opened={opened}
        onclose={() => {
          close();
          setIsViewOpen(false);
          setSelectedRow(null);
        }}
        isViewOpen={isViewOpen}
        setIsViewOpen={setIsViewOpen}
        data={selectedRow}
        date={date}
        allData={allData}
      />
    </div>
  );
};

export default MarMedicationModal;
